module.exports = __webpack_public_path__ + "img/Photo of our Story Founder.7498de03.jpg";